module.exports = __webpack_public_path__ + "media/src/images/partners/buckingham-b7e1c5f65335693fd77e9ae93abd29a2.jpg";